module.exports = __webpack_public_path__ + "img/197-d17c3b.png";